'use strict';

import each from 'lodash/each';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';

var SHGlobals = require('sh-globals'),
    SegmentUtils = require('utils/segment').default,

    defaultGoogleRemarketingData = {
        google_conversion_id: 985850933,
        google_conversion_label: '_qoXCPuwqQMQtciL1gM',
        google_remarketing_only: true
    },

    track = function track(trackingCalls) {
        if (!SHGlobals.isDeployed) { return; }

        if (isArray(trackingCalls)) {
            each(trackingCalls, trackingCall => {
                makeTrackingCall(trackingCall);
            });
        } else {
            makeTrackingCall(trackingCalls);
        }
    },

    makeTrackingCall = function makeTrackingCall({type, action, data, customData, defaultData, trackConversion}) {
        switch (type) {
            case 'google-remarketing':
                trackGoogleRemarketing(customData, defaultData, trackConversion);
                break;

            case 'google-analytics':
                trackGoogleAnalytics(data);
                break;
        }
    },

    trackGoogleRemarketing = function trackGoogleRemarketing(customData, defaultData, trackConversion) {
        var finalData = defaultGoogleRemarketingData;

        if (defaultData) {
            finalData = defaultData;
        }

        if (customData) {
            finalData.google_custom_params = customData;
        }

        if (trackConversion) {
            finalData.google_conversion_value = 1.00;
        }

        if (SHGlobals.isDeployed) {
            window.dataLayer.push({
                event: 'RemarketingEvent',
                remarketing_params: finalData // eslint-disable-line camelcase
            });
        } else {
            console.log('Google Remarketing: ', finalData); // eslint-disable-line no-console
        }
    },

    trackGoogleAnalytics = function trackGoogleAnalytics(data) {
        if (isUndefined(window.ga)) { return; }

        const {
            trackingType,
            page,
            eventCategory,
            eventAction,
            eventLabel
        } = data;

        if (SHGlobals.isDeployed) {
            switch (trackingType) {
                case 'page':
                    if (page) {
                        window.ga('send', 'pageview', page);
                    } else {
                        window.ga('send', 'pageview');
                    }
                    break;

                case 'event':
                    window.ga('send', 'event', eventCategory, eventAction, eventLabel);
                    break;
            }
        } else {
            console.log('Google Analytics - TrackingType: ', trackingType, ', Data:', data); // eslint-disable-line no-console
        }
    },

    appStoreLinkClicked = function appStoreLinkClicked(evt) {
        evt.preventDefault();

        const device = evt.currentTarget.getAttribute('data-device');
        const channel = evt.currentTarget.getAttribute('data-channel');

        if (isEmpty(channel)) {
            throw new Error('Channel attribute is required.');
        }

        if (!SHGlobals.isMobile && isEmpty(device)) {
            throw new Error('Device attribute is required for desktop browsers.');
        }

        // desktop leverages short links generated by the product team
        // mobile uses the branch sdk to generate links
        if (!SHGlobals.isMobile) {
            switch (device) {
                case 'ios':
                    switch (channel) {
                        case 'prepurchase':
                            window.open('https://bnc.lt/Eujc/TzuillX1Rs', '_blank');
                            break;

                        case 'postpurchase':
                            window.open('https://bnc.lt/Eujc/ddIi7wY1Rs', '_blank');
                            break;
                    }

                    break;

                case 'android':
                    switch (channel) {
                        case 'prepurchase':
                            window.open('https://bnc.lt/Eujc/TsP3lj21Rs', '_blank');
                            break;

                        case 'postpurchase':
                            window.open('https://bnc.lt/Eujc/dpblUp51Rs', '_blank');
                            break;
                    }

                    break;
            }

            return false;
        }

        const data = {
            channel
        };

        if (window.spotHeroUser && !isUndefined(window.spotHeroUser.email)) {
            data.email = window.spotHeroUser.email;
        }

        if (!isUndefined(window.branch)) {
            window.branch.link({
                data
            }, (err, link) => {
                if (!err) {
                    window.location = link;
                }
            });
        }
    },

    getSegmentId = function() {
        return SegmentUtils.getId();
    },

    getSegmentAnonymousId = function() {
        return SegmentUtils.getAnonymousId();
    },

    resetSegment = function() {
        if (isNil(window.analytics)) { return null; }

        window.analytics.reset();
    };



module.exports = window.SHAnalytics = {
    track,
    appStoreLinkClicked,
    getSegmentId,
    getSegmentAnonymousId,
    resetSegment
};



// WEBPACK FOOTER //
// ./spothero/static/main/js/analytics/sh-analytics.js